<template>
  <div>
    <div class="content">
      <div class="service_content">
        <p class="title">媒体报道</p>
        <p class="title2">媒体：第一财经 <span style="margin-left:20px;font-size:15px">2022-05-09</span> </p>
        <p class="title3">如何在A股践行价值投资-以深度定价能力研究探寻市场新机遇</p>
        <p class="text_content">
          随着中国证券市场的开放，2003年QFII进入中国，真正掀起了A股价值投资的风潮。从当年机构核心资产的五朵“金花”——煤炭、汽车、电力、银行与钢铁，到2007年底“钢铁、有色、金融、地产、煤炭”的空前高涨，再到2017年A股纳入MSCI新兴市场指数、贵州茅台的涨幅超倍突破了700元，价值投资理念在投资者中不断深入人心，但同样也不断遭受着质疑。
        </p>
        <a href="https://www.yicai.com/news/101405603.html" target="_blank" class="title4">>>更多内容</a>
        <p class="title2">媒体：21世纪经济报道<span style="margin-left:20px;font-size:15px">2022-05-09</span></p>
        <p class="title3">A股量化投资发展需正本清源-以多因子量化策略实现专业化投资</p>
        <p class="text_content">
          自上世纪七八十年代以来，量化投资已逐渐在全球金融市场占据重要地位。国内量化投资起步相对较晚，但从2015年以来发展速度较快。中基协数据显示，截至2021年年底，我国权益公募基金（股票型和混合型合计）规模约8.6万亿元，同比增长23.6%，其中量化类规模约2941亿元，占比约3.4%。证券类私募管理人管理规模约6.12 万亿，同比增长 62.6%，其中量化类规模约1.5万亿元，占比约24.8%。
        </p>
        <a href="https://www.21jingji.com/article/20220509/herald/d1572d6bb268c815845e4363a75afcaa.html" target="_blank" class="title4">>>更多内容</a>
        <p class="title2">媒体：北京商报 <span style="margin-left:20px;font-size:15px">2022-05-16</span></p>
        <p class="title3">看懂A股上市公司财务报表-以深度财务分析能力践行价值投资</p>
        <p class="text_content">
          面对新冠疫情、国际地缘冲突等复杂的外部环境，3月初以来上证指数出现了较大幅度的调整，至4月底终于再度打响暌违近两年的“3000点保卫战”。在这种跌跌不休的行情下，“关灯吃面”可能是不少投资者最无奈的抉择。也有投资者自嘲自己就像希腊神话里的西西弗斯，历经了自2008年以来A股的5轮3000点保卫战，却仍周而复始、永无止境。这样的行情再一次使得市场上充满“韭菜论”和“价值投资无用论”的质疑声，却选择性失忆似的淡忘了上一年初群体疯狂追逐核心资产的景象。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.content {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=59) no-repeat top;
  width: 100%;
  min-height: 600px;
  padding-top: 236px;
}
.service_content {
  width: 990px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 20px -5px #ccc;
  min-height: 530px;
  padding-bottom: 70px;
}
.service_content .title {
  color: #5f5f5f;
  border-bottom: 1px dashed #a8a8a8;
  line-height: 40px;
  font-size: 22px;
}
.text_content {
  text-indent: 2em;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #6f6f6f;
  padding: 10px 0;
  text-align: justify;
}
.title2 {
  font-size: 16px;
  color: #5a100d;
  margin: 18px 0;
}
.title3 {
  font-size: 14px;
  color: #4d5256;
  font-weight: bold;
  margin: 7px 0;
}
.title4 {
  font-size: 15px;
  color: #3e5074;
  float: right;
}
.title4 :visited{
  color: #3e5074;
}
</style>